let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8asz0")).then(() => parcelRequire('lIMc4'));